const INITIAL_PAGE = 1;
const INITIAL_ROWS_PER_PAGE = 10;

export default {
  ROWS_PER_PAGE: [5, 10, 15, 20],
  INITIAL_ROWS_PER_PAGE,
  INITIAL_PAGE,

  ASC: 'asc',
  DESC: 'desc',

  INITIAL_PAGINATON: {
    currentPage: INITIAL_PAGE,
    pageInterval: INITIAL_ROWS_PER_PAGE
  }
};
